<template src="./settings.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import { required, sameAs } from "vuelidate/lib/validators";

  import Icons from "@/assets/json_data/icons.json";
  import Multiselect from "vue-multiselect";

  // set counties data
  var iconsList = [];
  var keys = Object.keys(Icons);
  keys.forEach(function (key) {
    iconsList.push({ code: Icons[key], name: Icons[key] });
  });

  export default {
    components: {
      Multiselect,
    },
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
    },
    data() {
      return {
        SaveData: false,
         CompanyLinks: {
          links: [
            { title: "", link: "", icon: "", iframe: "" },
            { title: "", link: "", icon: "", iframe: "" },
            { title: "", link: "", icon: "", iframe: "" },
          ],
          external_links: [
            { title: "", link: "", icon: "", iframe: "" },
            { title: "", link: "", icon: "", iframe: "" },
            { title: "", link: "", icon: "", iframe: "" },
          ],
          license_check: [
            { penalty_point: "", duration: "" },
            { penalty_point: "", duration: "" },
            { penalty_point: "", duration: "" },
            { penalty_point: "", duration: "" },
            { penalty_point: "", duration: "" },
          ],
          inspections_frequency: "",
          stick_pmi_schedule: null,
          vehicle_check_minimum_time: 0,
          vehicle_check_duration: null,
          asset_check_minimum_time: 0,
          asset_check_duration: null,
        },
        submitted: false,
        Saving: false,
        SaveAdditionalSettings: false,
      };
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions["Settings"] ||
          !AccountPermissions["Settings"]["enable"])
      ) {
        this.$router.push("/");
      }
      if (
        AccountPermissions &&
        AccountPermissions.Settings &&
        AccountPermissions.Settings.enable
      ) {
        if (AccountPermissions.Settings.edit) {
          this.ShowSettingEdit = true;
        }
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowSettingEdit = true;
      }
      document.title = pbx_SiteTitle + " - Asset Settings";
      this.GetCompanyDetail();
    },

    methods: {
      GetCompanyDetail() {
        Axios.post(Endpoints.Company.Get, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            if (Response.data.company.fleet_settings_key != "") {
              var CompanySettingsKey = JSON.parse(
                Response.data.company.fleet_settings_key
              );
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.CompanyLinks != "undefined" &&
                CompanySettingsKey.CompanyLinks != ""
              ) {
                this.CompanyLinks.links = CompanySettingsKey.CompanyLinks;
              }
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.ExternalLinks != "undefined" &&
                CompanySettingsKey.ExternalLinks != ""
              ) {
                this.CompanyLinks.external_links =
                  CompanySettingsKey.ExternalLinks;
              }
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.LicenseCheck != "undefined" &&
                CompanySettingsKey.LicenseCheck != ""
              ) {
                this.license_check_data = [];
                for (var i = 0; i <= 4; i++) {
                  var obj = {};
                  obj["penalty_point"] = CompanySettingsKey.LicenseCheck[i]
                    ? CompanySettingsKey.LicenseCheck[i].penalty_point
                    : "";
                  obj["duration"] = CompanySettingsKey.LicenseCheck[i]
                    ? CompanySettingsKey.LicenseCheck[i].duration
                    : "";
                  this.license_check_data.push(obj);
                }
                this.CompanyLinks.license_check = this.license_check_data;
              }
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.InspectionsFrequency != "undefined" &&
                CompanySettingsKey.InspectionsFrequency != ""
              ) {
                this.CompanyLinks.inspections_frequency =
                  CompanySettingsKey.InspectionsFrequency;
              }
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.StickPMISchedule != "undefined" &&
                CompanySettingsKey.StickPMISchedule != ""
              ) {
                this.CompanyLinks.stick_pmi_schedule =
                  CompanySettingsKey.StickPMISchedule;
              }
              
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.VehicleCheckMinimumTime != "undefined" &&
                CompanySettingsKey.VehicleCheckMinimumTime != ""
              ) {
                this.CompanyLinks.vehicle_check_minimum_time =
                  CompanySettingsKey.VehicleCheckMinimumTime;
              }
              
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.VehicleCheckDuration != "undefined" &&
                CompanySettingsKey.VehicleCheckDuration != ""
              ) {
                this.CompanyLinks.vehicle_check_duration =
                  CompanySettingsKey.VehicleCheckDuration;
              }

              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.AssetCheckMinimumTime != "undefined" &&
                CompanySettingsKey.AssetCheckMinimumTime != ""
              ) {
                this.CompanyLinks.asset_check_minimum_time =
                  CompanySettingsKey.AssetCheckMinimumTime;
              }
             
              if (
                CompanySettingsKey != null &&
                typeof CompanySettingsKey.AssetCheckDuration != "undefined" &&
                CompanySettingsKey.AssetCheckDuration != ""
              ) {
                this.CompanyLinks.asset_check_duration =
                  CompanySettingsKey.AssetCheckDuration;
              }
            }
          }
        });
      },
      SetAssetCheckDurationStatus(status) {
        this.CompanyLinks.asset_check_duration = status;
      },
      UpdateCompanyLinks(type) {
        this.SaveData = true;
        Axios.post(Endpoints.Company.Links, {
          token: localStorage.getItem("token"),
          ...this.CompanyLinks,
        }).then((Response) => {
          if (Response?.data?.success) {
            var msg = "Setting Updated Successfully";
            this.$swal.fire(msg, "", "success").then(() => {
              this.SaveExternalData = false;
              this.SaveData = false;
              this.SaveLicense = false;
              this.SaveAdditionalSettings = false;
              this.$router.go();
            });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
    },
  };
</script>

<style scoped>
  .SettingDiv {
    height: 320px;
  }
  .h25 {
    height: 25px !important;
    vertical-align: middle;
    margin-top: 5px;
  }
  .penalty_point_div label {
    display: none;
  }
  .duration_div label {
    display: none;
  }
  @media (max-width: 760px) {
    .penalty_point_div label {
      display: block;
    }
    .duration_div label {
      display: block;
    }
  }
</style>
